import { render, staticRenderFns } from "./media-unsplash.vue?vue&type=template&id=6a90cc70&scoped=true&"
import script from "./media-unsplash.vue?vue&type=script&lang=js&"
export * from "./media-unsplash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90cc70",
  null
  
)

export default component.exports